<script>
  export let id;
  let prod = isProduction;
  if (typeof window !== "undefined" && isProduction) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", id);
  }
</script>

<svelte:head>
  {#if prod}
    <script
      async
      src="https://www.googletagmanager.com/gtag/js?id={id}"></script>
  {/if}
</svelte:head>
